Controller.$inject = ['$scope', '$element', '$transclude', '$timeout'];

function Controller($scope, $element, $transclude, $timeout) {
    const self = this;
    let menuElm, toggleElm;
    let isOpen = false;

    const detachMenu = () => {
        if (menuElm) {
            menuElm.style.display = 'none';
        }

        document.removeEventListener('click', handler);
    };

    const handler = (event) => {
        if (isOpen && !$element[0]?.contains(event.target)) {
            self.toggleMenu();
        }
    };

    self.toggleMenu = ($event) => {
        if (menuElm && toggleElm) {
            if (isOpen) {
                detachMenu();
                isOpen = false;
            } else {
                let options = {
                    placement: self.menuPlacement || 'bottom-end',
                    removeOnDestroy: true
                };

                if (self.enableFlip) {
                    options.modifiers = {
                        flip: {
                            enabled: false
                        }
                    };
                }
                self.onMenuOpen?.();
                isOpen = true;
                menuElm.style.display = 'block';
                menuElm.style.position = 'absolute';
                menuElm.style.top = '0px';
                menuElm.style.left = '0px';

                const hostElm = self.appendTo
                    ? document.querySelector(self.appendTo)
                    : document.body;
                hostElm.appendChild(menuElm);

                self.popper = new Popper(toggleElm, menuElm, options);
                $timeout(()=>{
                    const activeOrSelected = menuElm.querySelector('.hui-menu-item.active, .hui-menu-item.selected') || menuElm.querySelector('.hui-menu-item');
                    activeOrSelected?.scrollIntoView({block: 'nearest'});
                });
                document.addEventListener('click', handler);

            }
        }
    };

    self.$postLink = () => {
        $timeout(()=>{
            menuElm = $element[0].querySelector('.hui-menu');
            toggleElm = $element[0].querySelector('.dropdown-action');
            self.hasButtonIcon = $transclude.isSlotFilled('icon');
            self.hasButtonLabel = $transclude.isSlotFilled('label');
        });
    };

    self.$onDestroy = () => {
        detachMenu();
        self.popper?.destroy();
        self.popper = null;
    };
}

export function HuiButtonDropdown() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            iconVariant: '@',
            color: '@',
            sizing: '@',
            variant: '@',
            shape: '@',
            label: '@',
            btnAutomationId: '@',
            onMenuOpen: '&',
            appendTo: '@',
            menuPlacement: '@',
            autoFocus: '<',
            disabled: '<',
            noPadding: '<',
            openMenuToTop: '<',
            enableFlip: '<',
            isFullWidth: '<',
            maxHeight: '@?',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            'label': '?huiButtonLabel',
            'icon': '?huiButtonIcon',
            'items': '?huiDropdownItems'
        },
        template: ($element, $attrs) => {
            return `
                <span class="dropdown" ng-class="{'w-100': $huiCtrl.isFullWidth}">
                    <hui-button class="dropdown-action"
                                no-padding="$huiCtrl.noPadding"
                                is-full-width="$huiCtrl.isFullWidth"
                                ng-attr-automation="{{ $huiCtrl.btnAutomationId }}"
                                ng-click="$huiCtrl.toggleMenu($event)"
                                variant="{{$huiCtrl.variant}}"
                                shape="{{$huiCtrl.shape}}"
                                color="{{$huiCtrl.color}}"
                                sizing="{{$huiCtrl.sizing}}"
                                ng-disabled="$huiCtrl.disabled">
                            <ng-transclude class="d-contents" 
                                           ng-if="!$huiCtrl.label && $huiCtrl.iconVariant !== 'ellipsis'"
                                           ng-transclude-slot="label"></ng-transclude>
                            <span ng-if="$huiCtrl.label">{{$huiCtrl.label}}</span>
            
                            <ng-transclude class="d-contents" ng-if="!$huiCtrl.label && !$huiCtrl.hasButtonLabel" ng-transclude-slot="icon"></ng-transclude>
                            <i class="fas fa-chevron-down" ng-if="!$huiCtrl.hasButtonIcon && $huiCtrl.iconVariant !== 'ellipsis' && $huiCtrl.menuPlacement !== 'top'"></i>
                            <i class="fas fa-chevron-up" ng-if="!$huiCtrl.hasButtonIcon && $huiCtrl.iconVariant !== 'ellipsis' && $huiCtrl.menuPlacement === 'top'"></i>
                            <i class="fas fa-ellipsis-h" ng-if="!$huiCtrl.hasButtonLabel && !$huiCtrl.hasButtonIcon && $huiCtrl.iconVariant === 'ellipsis'"></i>
                    </hui-button>
                    <hui-menu max-height="{{$huiCtrl.maxHeight}}">
                        <ng-transclude ng-transclude-slot="items"></ng-transclude>
                    </hui-menu>
                </span>
            `;
        }
    };
}